import slices from './slices';

export default {
  ...slices.applicants.actions,
};
